module.exports = __webpack_public_path__ + "img/ceus-logo.47f8acff.png";